import * as React from 'react';
import { MessageDescriptor } from 'react-intl';

import {
  IconRegularPercent,
  ProductLabelModel,
  IconRegularDelivery,
  ProductTileModel,
  IconRegularGift,
  IconRegularCoupon,
  IconRegularStar,
  IconRegularProducts,
  IconRegularCrown,
} from '@notino/react-styleguide';

import messages from '@containers/ProductDetailContainer/messages';
import { AttributeType } from '@containers/ProductListing/model';

export interface ILabelAttribute {
  icon: JSX.Element;
  style: ProductLabelModel.ProductStyles;
  tooltipMessage?: MessageDescriptor;
}

export type ILabelAttributes = {
  [key in ProductTileModel.ProductLabelAttributes]: ILabelAttribute;
};

export const getLabelAttributes = (): Omit<
  ILabelAttributes,
  | ProductTileModel.ProductLabelAttributes.Niche
  | ProductTileModel.ProductLabelAttributes.VirtualTryOn
> => ({
  [ProductTileModel.ProductLabelAttributes.Action]: {
    style: ProductLabelModel.ProductStyles.highlighted,
    icon: <IconRegularPercent />,
  },
  [ProductTileModel.ProductLabelAttributes.FreeDelivery]: {
    style: ProductLabelModel.ProductStyles.highlighted,
    icon: <IconRegularDelivery />,
  },
  [ProductTileModel.ProductLabelAttributes.New]: {
    style: ProductLabelModel.ProductStyles.neutral,
    icon: <IconRegularStar />,
  },
  [ProductTileModel.ProductLabelAttributes.Clearance]: {
    style: ProductLabelModel.ProductStyles.highlighted,
    icon: <IconRegularPercent />,
  },
  [ProductTileModel.ProductLabelAttributes.VoucherDiscount]: {
    style: ProductLabelModel.ProductStyles.magenta,
    icon: <IconRegularCoupon />,
  },
  [ProductTileModel.ProductLabelAttributes.ConditionalVoucherDiscount]: {
    style: ProductLabelModel.ProductStyles.magenta,
    icon: <IconRegularCoupon />,
  },
  [ProductTileModel.ProductLabelAttributes.BargainSet]: {
    style: ProductLabelModel.ProductStyles.highlighted,
    icon: <IconRegularProducts />,
  },
  [ProductTileModel.ProductLabelAttributes.Damaged]: {
    style: ProductLabelModel.ProductStyles.neutral,
    icon: <IconRegularPercent />,
    tooltipMessage: messages.productDamaged,
  },
  [ProductTileModel.ProductLabelAttributes.Returned]: {
    style: ProductLabelModel.ProductStyles.neutral,
    icon: <IconRegularPercent />,
    tooltipMessage: messages.productReturned,
  },
  [ProductTileModel.ProductLabelAttributes.Gift]: {
    style: ProductLabelModel.ProductStyles.highlighted,
    icon: <IconRegularGift />,
  },
  [ProductTileModel.ProductLabelAttributes.Exclusive]: {
    style: ProductLabelModel.ProductStyles.neutral,
    icon: <IconRegularCrown />,
  },
});

export const getSupportedAttributes = () => [
  ProductTileModel.ProductLabelAttributes.New,
  ProductTileModel.ProductLabelAttributes.Action,
  ProductTileModel.ProductLabelAttributes.Clearance,
  ProductTileModel.ProductLabelAttributes.FreeDelivery,
  ProductTileModel.ProductLabelAttributes.Damaged,
  ProductTileModel.ProductLabelAttributes.Returned,
  ProductTileModel.ProductLabelAttributes.VirtualTryOn,
  ProductTileModel.ProductLabelAttributes.BargainSet,
  ProductTileModel.ProductLabelAttributes.Gift,
  ProductTileModel.ProductLabelAttributes.Exclusive,
];

export const getSupportedCornerAttributes = () => [
  ProductTileModel.ProductLabelAttributes.FreeDelivery,
  ProductTileModel.ProductLabelAttributes.Action,
  ProductTileModel.ProductLabelAttributes.Clearance,
  ProductTileModel.ProductLabelAttributes.VoucherDiscount,
  ProductTileModel.ProductLabelAttributes.ConditionalVoucherDiscount,
  ProductTileModel.ProductLabelAttributes.New,
  ProductTileModel.ProductLabelAttributes.Gift,
  ProductTileModel.ProductLabelAttributes.Exclusive,
];

export interface ITagsProps {
  attributes?: AttributeType;
  stockAvailability: string;
  small?: boolean;
  multiple?: boolean;
  type?: ProductLabelModel.Types;
  icon?: string;
  onClick?: (attribute: ProductTileModel.ProductLabelAttributes) => void;
  nowrapLg?: boolean;
  customFilter?: (
    tagAttributes: ProductTileModel.ProductLabelAttributes
  ) => boolean;
}
